export default __webpack_public_path__ + "static/media/user1.946ac1a1.png";